import { V4UUID, workspaceState } from '@/firebase/database';
import { defineStore } from 'pinia';
import { useGlobalStore } from '../globalModule/store';
export const useCodeViewStore = defineStore({
  id: 'codeView',
  state: (): {} => {
    return { workspaceId: null, fileTreeRoot: null };
  },
  actions: {}
});
